export default __webpack_public_path__ + "static/media/13AW1FEB66.b043818a.jpg";